import * as React from 'react';
import '../css/multi-component.sass';

interface MultiComponentProps {
  children: React.ReactElement;
  onChange?: Function;
  values?: any[];
  maxChildren?: number;
}

interface MultiComponentState {
  values: any[];
  events: any[];
}

export default function MultiComponent(props: MultiComponentProps) {
  const { values = [''] } = props;

  const [state, setState] = React.useState<MultiComponentState>({
    values,
    events: []
  });

  const updateLine = (newValues: any[], newEvents: any[], index: number) => {
    setState({
      ...state,
      values: newValues,
      events: newEvents
    });
    if (props.onChange) {
      props.onChange(newValues, newEvents, index);
    }
  };

  const addLine = () => {
    const newValues = [...state.values, ''];
    const newEvents = [...state.events, undefined];
    updateLine(newValues, newEvents, state.values.length);
  };

  const removeLine = (index: number) => {
    const newValues = [...state.values.filter((value, i) => index !== i)];
    const newEvents = [...state.events.filter((value, i) => index !== i)];
    updateLine(newValues, newEvents, index);
  };

  React.useEffect(() => {
    if (props.values) {
      setState({
        events: [],
        values: props.values
      });
    }
  }, [props.values]);

  let keyIndex = 0;

  return (
    <>
      {state.values.map((value, index) => {
        keyIndex += 1;
        return (
          <span className="row" key={`${props.children.props?.id}${keyIndex}`}>
            <span className="col-9">
              {React.cloneElement(props.children, {
                name: `${props.children.props?.name}${index + 1}`,
                id: `${props.children.props?.id}${index + 1}`,
                value: state.values[index],
                onChange: (v: any) => {
                  const newValues = [...state.values];
                  const newEvents = [...state.events];
                  newEvents[index] = v;
                  newValues[index] = v.target ? v.target.value : v;
                  setState({ ...state, values: newValues, events: newEvents });
                  if (props.onChange) {
                    props.onChange(newValues, newEvents, index);
                  }
                }
              })}
            </span>
            <span className="col-3 row multi-icons">
              {state.values?.length > 1 && (
                <div
                  role="button"
                  className="multi-icon minus-icon"
                  tabIndex={0}
                  onClick={() => removeLine(index)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      removeLine(index);
                    }
                  }}
                >
                  <span className="horizontal"></span>
                </div>
              )}
              {state.values &&
                index === state.values.length - 1 &&
                (!props.maxChildren ||
                  props.maxChildren > state.values.length) && (
                  <div
                    role="button"
                    className="multi-icon plus-icon"
                    tabIndex={0}
                    onClick={() => addLine()}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        addLine();
                      }
                    }}
                  >
                    <span className="horizontal"></span>
                    <div className="vertical"> </div>
                  </div>
                )}
            </span>
          </span>
        );
      })}
    </>
  );
}
